export enum AnalyticsEvent {
  ButtonClick = "button_click",
  GlobalErrorBoundaryHit = "global_error_boundary_hit",
  TestErrorFrontend = "test_error_frontend",
  TestEventFrontend = "test_event_frontend",
  TopLevelEvent = "top_level_event",
}
